import React, { useReducer } from 'react';

import RMDModal from '../components/ComposeFAQ/RMDModal';
import DeleteModal from '../components/DeleteModal/DeleteModal';
import SendConfirmationModal from '../components/SendConfirmationModal/SendConfirmationModal';
import SendErrorModal from '../components/SendErrorModal/SendErrorModal';
import Modal from '../shared/Modal/Modal';

export const useModal = (apiKey, updateSentMessageCache, env) => {
  const [
    { showModal, type = '', additionalState = {} },
    dispatchModal
  ] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SHOW':
          return {
            additionalState: action.payload,
            showModal: true,
            type: action.payload.type
          };
        case 'HIDE':
          return {
            showModal: false
          };
        default:
          return {
            showModal: false
          };
      }
    },
    { showModal: false }
  );

  const modalBodies = {
    delete: DeleteModal,
    rmd: RMDModal,
    send: SendConfirmationModal,
    sendError: SendErrorModal
  };

  const closeModal = () => dispatchModal({ type: 'HIDE' });

  return {
    closeModal,
    // eslint-disable-next-line
    Modal: ({ children, ...p }) => {
      const Component = modalBodies[type];
      return (
        showModal && (
          <Modal closeModal={closeModal} closeOnDocumentClick={type!=='send'} showModal={showModal} {...p} type={type}>
            <Component
              apiKey={apiKey}
              closeModal={closeModal}
              env={env}
              updateSentMessageCache={updateSentMessageCache}
              {...p}
              {...additionalState}
            />
          </Modal>
        )
      );
    },
    openModal: payload => dispatchModal({ payload, type: 'SHOW' })
  };
};
